/* tslint:disable:max-line-length */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = []
// export const defaultNavigation: FuseNavigationItem[] = [
//     {
//         id      : 'dashboards',
//         title   : 'Dashboards and Reports',
//         // subtitle: 'Unique dashboard designs',
//         type    : 'group',
//         icon    : 'heroicons_outline:home',
//         children: [
//             {
//                 id   : 'dashboards.project',
//                 title: 'Project',
//                 type : 'basic',
//                 icon : 'heroicons_outline:clipboard-check',
//                 link : '/dashboards/project'
//             },
//             {
//                 id   : 'dashboards.analytics',
//                 title: 'Analytics',
//                 type : 'basic',
//                 icon : 'heroicons_outline:chart-pie',
//                 link : '/dashboards/analytics'
//             },
//             {
//                 id   : 'dashboards.reports',
//                 title: 'Reports',
//                 type : 'basic',
//                 icon : 'heroicons_outline:chart-pie',
//                 link : '/apps/reports'
//             }
//         ]
//     },
//     // {
//     //     id   : 'example',
//     //     title: 'Help',
//     //     type : 'basic',
//     //     icon : 'heroicons_outline:chart-pie',
//     //     link : '/example'
//     // },
//     {
//         id      : 'apps',
//         title   : 'Applications',
//         subtitle: 'Custom made apps for you',
//         type    : 'group',
//         icon    : 'heroicons_outline:home',
//         children: [
//             {
//                 id   : 'apps.reception',
//                 title: 'Reception',
//                 type : 'basic',
//                 icon : 'heroicons_outline:user-group',
//                 link : '/apps/reception'
//             },
//             {
//                 id      : 'apps.consult',
//                 title   : 'Consult',
//                 subtitle: '3 upcoming events',
//                 type    : 'basic',
//                 icon    : 'heroicons_outline:calendar',
//                 link    : '/apps/consult'
//             },
//             {
//                 id   : 'apps.transport',
//                 title: 'Transportation',
//                 type : 'basic',
//                 icon : 'heroicons_outline:truck',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.pharmacy',
//                 title: 'Pharmacy',
//                 type : 'basic',
//                 icon : 'heroicons_outline:beaker',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.labs',
//                 title: 'Lab',
//                 type : 'basic',
//                 icon : 'heroicons_outline:table',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.bloodbank',
//                 title: 'Blood Bank',
//                 type : 'basic',
//                 icon : 'approval',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.bloodbank',
//                 title: 'ERP',
//                 subtitle: 'expenses and procurement',
//                 type : 'basic',
//                 icon : 'heroicons_outline:cash',
//                 link : '/apps/erp'
//             },
//             {
//                 id   : 'apps.diet',
//                 title: 'Diet Management',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.assets',
//                 title: 'Asset Management',
//                 type : 'basic',
//                 icon : 'heroicons_outline:server',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.laundry',
//                 title: 'Linen & Laundry',
//                 type : 'basic',
//                 icon : 'heroicons_outline:sun',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.billing',
//                 title: 'MRD',
//                 type : 'basic',
//                 subtitle: 'Medical Record Department',
//                 icon : 'heroicons_outline:currency-rupee',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.billing',
//                 title: 'Nursing Station',
//                 type : 'basic',
//                 icon : 'heroicons_outline:currency-rupee',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.billing',
//                 title: 'Insurance',
//                 type : 'basic',
//                 icon : 'heroicons_outline:currency-rupee',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.billing',
//                 title: 'Billing',
//                 type : 'basic',
//                 icon : 'heroicons_outline:currency-rupee',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'OT and Anesthesia',
//                 type : 'basic',
//                 icon : 'heroicons_outline:scissors',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'IPD and Emergency',
//                 type : 'basic',
//                 icon : 'bed',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'Duty Roster',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'Attendance',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'Payroll',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'BMed Waste',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'Enquiry',
//                 type : 'basic',
//                 icon : 'heroicons_outline:users',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'External Interactions',
//                 type : 'basic',
//                 icon : 'heroicons_outline:switch-horizontal',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'CSSD',
//                 type : 'basic',
//                 icon : 'heroicons_outline:academic-cap',
//                 link : '/apps/reception'
//             },
//             {
//                 id   : 'apps.OTandAnesthesia',
//                 title: 'NDHM',
//                 type : 'basic',
//                 icon : 'heroicons_outline:view-list',
//                 link : '/apps/reception'
//             }

//         ]
//     },
//     {
//         id  : 'divider-1',
//         type: 'divider'
//     },
//     {
//         id      : 'gapps',
//         title   : 'General Applications',
//         subtitle: 'Addon apps',
//         type    : 'group',
//         icon    : 'heroicons_outline:home',
//         children: [
//             {
//                 id   : 'gapps.contacts',
//                 title: 'Contacts',
//                 type : 'basic',
//                 icon : 'heroicons_outline:user-group',
//                 link : '/apps/contacts'
//             },
//             {
//                 id   : 'gapps.notes',
//                 title: 'Notes',
//                 type : 'basic',
//                 icon : 'heroicons_outline:pencil-alt',
//                 link : '/apps/notes'
//             },
//             {
//                 id   : 'gapps.tasks',
//                 title: 'Tasks',
//                 type : 'basic',
//                 icon : 'heroicons_outline:check-circle',
//                 link : '/apps/tasks'
//             }
//         ]
//     },
//     {
//         id  : 'divider-1',
//         type: 'divider'
//     },
//     {
//         id      : 'help',
//         title   : 'SETUP & HELP',
//         subtitle: 'Everything you need to know',
//         type    : 'group',
//         icon    : 'heroicons_outline:support',
//         children: [
//             {
//                 id   : 'help.setup',
//                 title: 'Setup',
//                 type : 'basic',
//                 icon : 'heroicons_outline:cog',
//                 link : '/setup'
//             },
//             {
//                 id   : 'help.appstore',
//                 title: 'Apps',
//                 type : 'basic',
//                 icon : 'apps',
//                 link : '/appstore'
//             },
//             {
//                 id   : 'help.help-center',
//                 title: 'Help center',
//                 type : 'basic',
//                 icon : 'heroicons_outline:support',
//                 link : '/apps/help'
//             },
//             {
//                 id   : 'help.change-log',
//                 title: 'Chagelog',
//                 type : 'basic',
//                 icon : 'heroicons_outline:speakerphone',
//                 link : '/help/changelog'
//             },
//             {
//                 id   : 'help.support',
//                 title: 'Support',
//                 type : 'basic',
//                 icon : 'heroicons_outline:ticket',
//                 link : '/apps/support'
//             },
//             // {
//             //     id      : 'apps.help-center',
//             //     title   : 'Help center',
//             //     type    : 'collapsable',
//             //     icon    : 'heroicons_outline:support',
//             //     link    : '/apps/help-center',
//             //     children: [
//             //         {
//             //             id   : 'help.changelog',
//             //             title: 'Changelog',
//             //             type : 'basic',
//             //             icon : 'heroicons_outline:speakerphone',
//             //             link : '/help/changelog',
//             //             badge: {
//             //                 title  : '1.0.0',
//             //                 classes: 'px-2 bg-yellow-300 text-black rounded-full'
//             //             }
//             //         },
//             //         {
//             //             id   : 'help.tutorials',
//             //             title: 'Tutorials',
//             //             type : 'basic',
//             //             icon : 'heroicons_outline:book-open',
//             //             link : '/apps/tutorials'
//             //         },
//             //         {
//             //             id   : 'help.guides',
//             //             title: 'How Tos',
//             //             type : 'basic',
//             //             icon : 'heroicons_outline:book-open',
//             //             link : '/help/guides'
//             //         },
//             //         {
//             //             id   : 'help.faqs',
//             //             title: 'FAQs',
//             //             type : 'basic',
//             //             icon : 'heroicons_outline:book-open',
//             //             link : '/apps/help/faqs'
//             //         },
//             //         {
//             //             id   : 'help.support',
//             //             title: 'Support',
//             //             type : 'basic',
//             //             icon : 'heroicons_outline:question-mark-circle',
//             //             link : '/apps/support'
//             //         }
//             //     ]
//             // },
//             // {
//             //     id   : 'help.setup',
//             //     title: 'Setup',
//             //     type : 'basic',
//             //     icon : 'heroicons_outline:cog',
//             //     link : '/setup'
//             // }

//         ]
//     }
// ];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'Dashboards',
        tooltip : 'Dashboards',
        type    : 'aside',
        icon    : 'heroicons_outline:home',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'Apps',
        tooltip : 'Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'gapps',
        title   : 'Apps',
        tooltip : 'General Apps',
        type    : 'aside',
        icon    : 'heroicons_outline:qrcode',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'help',
        title   : 'Help',
        tooltip : 'Help',
        type    : 'aside',
        icon    : 'heroicons_outline:book-open',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'settings',
        title   : 'Settings',
        tooltip : 'Settings',
        type : 'basic',
        icon    : 'heroicons_outline:cog',
        link : '/apps/help-center/support'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id      : 'dashboards',
        title   : 'DASHBOARDS',
        type    : 'group',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'apps',
        title   : 'APPS',
        type    : 'group',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id   : 'others',
        title: 'OTHERS',
        type : 'group'
    },
    {
        id      : 'pages',
        title   : 'Pages',
        type    : 'aside',
        icon    : 'heroicons_outline:document-duplicate',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'user-interface',
        title   : 'User Interface',
        type    : 'aside',
        icon    : 'heroicons_outline:collection',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id      : 'navigation-features',
        title   : 'Navigation Features',
        type    : 'aside',
        icon    : 'heroicons_outline:menu',
        children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    }
];
export const horizontalNavigation: FuseNavigationItem[] = []

// export const horizontalNavigation: FuseNavigationItem[] = [
    // {
    //     id      : 'dashboards',
    //     title   : 'Dashboards',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:home',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'apps.reception',
    //     title   : 'Ramya',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:qrcode',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'apps.consult',
    //     title   : 'CONSULT',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:qrcode',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'gapps',
    //     title   : 'GENERAL Apps',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:qrcode',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'pages',
    //     title   : 'Pages',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:document-duplicate',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'user-interface',
    //     title   : 'UI',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:collection',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id      : 'navigation-features',
    //     title   : 'Misc',
    //     type    : 'group',
    //     icon    : 'heroicons_outline:menu',
    //     children: [] // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    // },
    // {
    //     id   : 'example',
    //     title: 'Example',
    //     type : 'basic',
    //     icon : 'heroicons_outline:chart-pie',
    //     link : '/example'
    // }
// ];
